import { render, staticRenderFns } from "./TemplateConjugation.vue?vue&type=template&id=5d1fc22d&scoped=true&"
import script from "./TemplateConjugation.vue?vue&type=script&lang=js&"
export * from "./TemplateConjugation.vue?vue&type=script&lang=js&"
import style0 from "./TemplateConjugation.vue?vue&type=style&index=0&id=5d1fc22d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d1fc22d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VIcon,VRow})
